import { render, staticRenderFns } from "./PermissionStep.vue?vue&type=template&id=3a326bac&scoped=true"
import script from "./PermissionStep.vue?vue&type=script&lang=js"
export * from "./PermissionStep.vue?vue&type=script&lang=js"
import style0 from "./PermissionStep.vue?vue&type=style&index=0&id=3a326bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a326bac",
  null
  
)

export default component.exports